export default __webpack_public_path__ + "2c194b918684016e128812e397459ad0.svg";